import { api } from "../../api";
import { NETWORK_ENDPOINTS } from "../../../constants/endpoints";

export const networkApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAllNetworks: builder.query({
      query: () => ({
        url: NETWORK_ENDPOINTS.GET_ALL,
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({ page: 1, pageSize: 100 }).toString(),
      }),
      providesTags: ["Network"],
    }),
  }),
  overrideExisting: false,
});

export const { useGetAllNetworksQuery } = networkApi;
